// import 'animate.css';
// import Swiper, {Navigation} from 'swiper';
// import 'swiper/css';
// import 'swiper/css/navigation';
import './scss/block_2.scss';
import moment from 'moment';

function loadBar(element) {
	let runday;
	let saveday = [];
	let percentBar_1;
	let dayCurrent;
	let keyCurrent;
	let valueBar = [];
	let minBar;
	const keyDay = Object.keys($('.item-' + element).data('day'));
	const valueDay = Object.values($('.item-' + element).data('day'));
	const now = moment();

	let isFirstIteration = false;
	for (const [key, value] of Object.entries($('.item-' + element).data('day'))) {
		if (!isFirstIteration) {
			runday = $('.startday').data('day');
			saveday.push(value);
			isFirstIteration = true;
			valueBar.push((500*key)/100);
			if (moment(value).isAfter(now)) {
				minBar = 0;
				percentBar_1 = (500*key)/100;
				dayCurrent = value;
				keyCurrent = key;
				break;
			};
		} else {
			runday = saveday[saveday.length - 1];
			saveday.push(value);
			valueBar.push((500*key)/100);
			if (moment(value).isAfter(now)) {
				minBar = valueBar[valueBar.length - 2];
				percentBar_1 = ((500*key)/100) - minBar;
				dayCurrent = value;
				keyCurrent = key;
				break;
			};

		}
	};

	const momentTarget_1 = moment(dayCurrent, 'YYYY-MM-DD HH:mm:ss')
	const totalTime_now = momentTarget_1.diff(now, 'second');

	const startday = moment(runday, 'YYYY-MM-DD HH:mm:ss'); 
	const totalTime_1 = momentTarget_1.diff(startday, 'seconds');

	const resultBar_1 = ( (totalTime_1 - totalTime_now) / totalTime_1 ) * 100;
	let resultHTML_1 = (resultBar_1*percentBar_1)/100;
	if (isNaN(resultHTML_1)) {
		$('.boat-' + element).css('left','500px');
		$('.item-' + element).find('.current').css('width','677px');
	} else {
		$('.boat-' + element).css('left',minBar + resultHTML_1);
		const barPercent = ((677*keyCurrent)/100);
		const barCurrent = (barPercent * resultBar_1)/100 + minBar;
		$('.item-' + element).find('.current').css('width',barCurrent + 50);
	};
};

loadBar(1);
loadBar(2);
loadBar(3);
loadBar(4);